import { walletsApi,walletsgridClient, web3Client} from "../../api/clients"
import { ApiControllers } from '../../api/config';
const environment = process.env.REACT_APP_WALLET_TYPE;



const getTransactions=(id,type,pageNo,pageSize)=>{
	if(environment === 'non_custodial'){
        return web3Client.get(ApiControllers.exchangetransaction+ `wallets/transactions/${id}/${type}?page=${pageNo}&pageSize=${pageSize}`) 
    }else{
		return walletsgridClient.get(ApiControllers.exchangetransaction+ `wallets/transactions/${id}/${type}?page=${pageNo}&pageSize=${pageSize}`)
    }
}
//neowalletapi.azurewebsites.net/api/v1/Transactions/Customers/Deposit/Dashboard/Deposit
const getDepositTransactions=(type)=>{
	if(environment === 'non_custodial'){
        return web3Client.get(ApiControllers.transactions+ `Customers/${type}/Dashboard/${type}`) 
    }else{
		return walletsApi.get(ApiControllers.transactions+ `Customers/${type}/Dashboard/${type}`)
    }
}
//neowalletapi.azurewebsites.net/api/v1/Transactions/Customers/Withdraw/Dashboard/Withdraw
const getWithdrawTransactions=()=>{
	if(environment === 'non_custodial'){
        return web3Client.get(ApiControllers.transactions+ `Customers/Withdraw/Dashboard/Withdraw`)
    }else{
		return walletsApi.get(ApiControllers.transactions+ `Customers/Withdraw/Dashboard/Withdraw`)
    }
}

const getTransactionDetails=(id,type)=>{
	if(environment === 'non_custodial'){
        return web3Client.get(ApiControllers.exchangetransaction+ `Wallets/transaction/${id}`)
    }else{
		return walletsApi.get(ApiControllers.exchangetransaction+ `Wallets/transaction/${id}`)
    }
}
const downloadTransaction=(id,type)=>{
	if(environment === 'non_custodial'){
        return web3Client.get(ApiControllers.exchangetransaction + `TemplatesTranction/${id}/${type}`);
    }else{
		return walletsApi.get(ApiControllers.exchangetransaction + `TemplatesTranction/${id}/${type}`);  
    }
}

export {
   getTransactions,getTransactionDetails,downloadTransaction,getDepositTransactions,getWithdrawTransactions
}
